import React, { Component } from 'react';
import { connect }          from 'react-redux';
import LoadingSvg           from './../../LoadingSvg';
import { Map }              from './../Map';
import { saveZoom, setMapObject }
                            from './../../../actions/MapAction';

class MapContainer extends Component
{
    state = {
        position: null,
        zoom    : null
    };

    componentWillMount = () =>
    {
        if (false !== this.props.listView) {
            this.setState({ zoom: this.props.map.zoom });
        }
    };

    componentWillReceiveProps = (nextProps) =>
    {
        if (false !== this.props.listView && nextProps.map.zoom !== this.props.map.zoom)
        {
            this.setState({ zoom: nextProps.map.zoom });
        }
    };

    //---------------------------------------------------------------------------------------------------------------

    shouldComponentUpdate = (nextProps) =>
    {
        return !(false === this.props.map.mapObject && false !== nextProps.map.mapObject);
    };

    //---------------------------------------------------------------------------------------------------------------

    getOrigin = () =>
    {
        let origin;

        if (this.props.geo.coords)
        {
            let { coords } = this.props.geo;
            origin = { lat: coords.latitude, lng: coords.longitude };
        }

        return origin;
    };

    //---------------------------------------------------------------------------------------------------------------

    getUserPosition = () =>
    {
        let coords = null;

        if (this.props.geo.coords)
        {
            coords = this.props.geo.coords;
        }

        return coords;
    };

    //---------------------------------------------------------------------------------------------------------------

    render = () => 
    {
        return (
            <div className="places-map">
                <div className="map">
                    <Map
                        loadingElement={
                            <div style={ { height: '100%' } }>
                                <LoadingSvg />
                            </div>
                        }
                        containerElement={ <div style={{ height: '100%' }} /> }
                        mapElement={ <div style={{ height: '100%' }} /> }
                        places={ this.props.places }
                        otherPlaces={ this.props.otherPlaces }
                        zoom={ this.state.zoom }
                        kml={ this.props.kml }
                        origin={ this.getOrigin() }
                        user={ this.getUserPosition() }
                        setMapObject={ this.props.setMap }
                        directions={ this.props.directions.result }
                        saveZoom={ this.props.saveZoom }
                        listView={ this.props.listView }
                        showTrails={ this.props.showTrails }
                    />
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state) =>
{
    return {
        directions: state.directions,
        geo       : state.geo,
        map       : state.map
    };
};

const mapDispatchToProps = (dispatch) =>
{
    return {
        saveZoom: (zoom) =>
        {
            dispatch(saveZoom(zoom));
        },
        setMap: (map) =>
        {
            dispatch(setMapObject(map));
        }
    };
};

MapContainer.defaultProps = {
    kml        : null,
    listView   : false,
    otherPlaces: [],
    showTrails : false
};

MapContainer = connect(mapStateToProps, mapDispatchToProps)(MapContainer);

export default MapContainer;



// WEBPACK FOOTER //
// ./src/components/Map/containers/MapContainer.js